/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { RiPushpinFill } from "react-icons/ri";
import { RiArrowDownSLine, RiChatNewFill } from "react-icons/ri";
import { FaEnvelopeOpenText, FaFile, FaUserCircle } from "react-icons/fa";
import { CiCircleInfo } from "react-icons/ci";
import { IoMdClose, IoMdRefresh } from "react-icons/io";
import { IoMdArrowRoundBack, IoMdSend } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { IoClose, IoSearch } from "react-icons/io5";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-tooltip";
import BarLoader from "react-spinners/BarLoader";
import {
  MdAttachFile,
  MdBlockFlipped,
  MdOutlineKeyboardBackspace,
} from "react-icons/md";
import {
  BsFiletypeDoc,
  BsFiletypeDocx,
  BsFiletypePdf,
  BsFiletypeXls,
  BsFiletypeXlsx,
} from "react-icons/bs";
import socket from "../../socket";
import {
  ChatsType,
  LastViewType,
  MessageDetailsType,
  NumbersType,
  ShortcutMessageType,
  TypingUsersType,
  ViewersType,
  SearchResponse,
  SmsGatewayNumber,
  GrammerErrorType,
  NumberDetails,
} from "../../type";
import PulseLoader from "react-spinners/PulseLoader";
import { useMutation, useQuery } from "react-query";
import {
  CreateMessageApi,
  ShortcutMessagesApi,
  MessageDetailsApi,
  RetryMessageApi,
  SearchNumberMessageApi,
  CampaignNumbersApi,
  OneToOneMessageAPI,
  UserNumberPin,
  UserNumberPinDelete,
  Disposition_StatusList,
  Disposition_Number_Wise_List,
} from "../../Api";
import { toast } from "sonner";
import { AxiosResponse } from "axios";
import { MessageSchema, OneToOneMessageSchema } from "../../Validation";
import { ErrorMessage, Field, Formik, Form, useFormik } from "formik";
import { formatDate } from "../../../helper";
import { saveAs } from "file-saver";
import AddBlocklist from "./AddBlocklist";
import Blocklist from "./Blocklist";
import DeleteBlocklist from "./DeleteBlocklist";
import GrammarValidator from "../../../Components/GrammarValidator";
import ImageModal from "../../../Components/ImageModal";
import Select from "react-select";
import AddStatus from "./AddStatus";
import { Virtuoso } from "react-virtuoso";

export const DateFormat = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "America/New_York",
  });
};

let colors = ["olive", "cyan", "purple", "indigo", "maroon", "navy", "orange"];

interface MessageType {
  message: string;
  media: File[];
}

export const isJSONString = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch (_) {
    return false;
  }
};
export default function ChatBox() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [numbers, setNumbers] = useState<NumbersType[]>([]);
  const [unReadNumbers, setUnReadNumbers] = useState<NumbersType[]>([]);
  const [totalUnreadCount, setTotalUnreadCount] = useState<number | null>(null);
  const [openChat, setOpenChat] = useState("");
  const [Chats, setChats] = useState<ChatsType[]>([]);
  const [Viewers, setViewers] = useState<ViewersType[]>([]);
  const [isTyping, setIsTyping] = useState(false);
  const [isTextBoxFocus, setIsTextBoxFocus] = useState(false);
  const [typingUsers, setTypingUsers] = useState<TypingUsersType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSugestion, setShowSugesation] = useState(false);
  const MediaInputRef = useRef<HTMLInputElement>(null);
  const MediaInputRef2 = useRef<HTMLInputElement>(null);
  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState("");
  const [shortcutMessages, setShortcutMessages] = useState<
    ShortcutMessageType[]
  >([]);
  const [MessageDetails, setMessagesDetails] =
    useState<MessageDetailsType | null>(null);
  const [SearchDetails, setSearchDetails] = useState<SearchResponse | null>(
    null
  );
  const [ChatBoxGrammerError, setChatBoxGrammerError] = useState<
    GrammerErrorType[]
  >([]);
  const [OneToOneGrammerError, setOneToOneGrammerError] = useState<
    GrammerErrorType[]
  >([]);
  const [smsId, setSmsId] = useState<number | null>(null);
  const [LastView, setLastView] = useState<LastViewType | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAddBlocklist, setShowAddBlockList] = useState(false);
  const [showStausList, setShowStausList] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [showUnblocklist, setShowUnblockList] = useState(false);
  const [NumberFilter, setNumberFilter] = useState<
    "All" | "Blocklist" | "Unread"
  >("All");
  const [SearchBlocklistNumber, setSearchBlockListNumber] = useState("");
  const [isBlockedNumber, setIsBlockedNumber] = useState(false);
  const [loading, setLoading] = useState({ number: true, message: false });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [loader, setloader] = useState(false);
  const [oneToOneSendLoader, setOneToOneLoader] = useState(false);
  const [isGrammerValidating, setIsGrammerValidating] = useState({
    chatBox: false,
    oneToOne: false,
  });
  const [gatewayNumbers, setGatewayNumbers] = useState<SmsGatewayNumber[]>([]);
  const [dispositionStatus, setDispositionStatus] = useState<
    { value: number; label: string }[]
  >([]);
  const [statusInitialValue, setStatusInitialValue] = useState<any>([]);
  const [messageListInfo, setMessageListInfo] = useState({
    count: 0,
    current_page: 1,
    limit: 5,
    total_page: 1
  });
  const chatListContainerRef = useRef<HTMLDivElement>(null);
  const [isChatListLoaded, setIsChatListLoaded] = useState(false);
  const [isFirstChatListLoaded, setIsFirstChatListLoaded] = useState(false);

  const handleScroll = () => {
    const el = chatListContainerRef.current;
    if (!el) return;

    const scrollTop = el.scrollTop;
    if (scrollTop === 0 && isFirstChatListLoaded && isChatListLoaded && messageListInfo.current_page < messageListInfo.total_page) {
      setIsChatListLoaded(false);
      socket.emit("Chats", { campaignId: state?.id, number: openChat, page: messageListInfo.current_page + 1, isAppend: true });
    }
  };

  useEffect(() => {
    const el = chatListContainerRef.current;
    if (!el) return;

    el.addEventListener('scroll', handleScroll);

    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  const Disposition_status = useQuery({
    queryKey: ["Get_Disposition_Status"],
    queryFn: Disposition_StatusList,
    onSuccess: (resp: AxiosResponse) => {
      const formattedData =
        resp?.data?.data?.map((item: { id: number; status: string }) => ({
          value: item.id,
          label: item.status,
        })) || [];

      setDispositionStatus(formattedData);
    },
    enabled: true,
  });

  const Initial_Disposition_Status = useQuery({
    queryKey: ["Get_Disposition_Status", openChat, state.id],
    queryFn: Disposition_Number_Wise_List,
    onSuccess: (resp: AxiosResponse) => {
      const data = resp?.data?.data;
      setStatusInitialValue(data);
    },
    enabled: !!openChat,
  });

  const handleStatusChange = (selectedOption: any) => {
    if (!selectedOption || selectedOption.value === "") {
      setSelectedStatus("");
      return;
    }
    setSelectedStatus(selectedOption.label);
    setShowStausList(true);
    Initial_Disposition_Status.refetch();
  };

  const CampaignNumber = useQuery({
    queryKey: ["Get_Campaign_Numbers", state.id],
    queryFn: CampaignNumbersApi,
    onSuccess: (resp: AxiosResponse) => {
      setGatewayNumbers(
        resp?.data?.CampaignNumbers?.sms_gateways_numbers || []
      );
    },
    enabled: false,
  });
  const [showMenuDropdown, setShowMenuDrodown] = useState<null | number>(null);
  useEffect(() => {
    if (state.id) CampaignNumber.refetch();
  }, [state.id]);

  const UserChatPin = useMutation(UserNumberPin, {
    mutationKey: "User-Chat-Pin-Create",
    onSuccess: (data: any) => {
      setIsLoading(false);
      setloader(false);
    },
    onError: (data: any) => {
      setIsLoading(false);
      setloader(false);
      toast.error(data?.response?.data?.message || "Something wrong.");
    },
  });

  const UserChatPinDelete = useMutation(UserNumberPinDelete, {
    mutationKey: "User-Chat-Pin-Delete",
    onSuccess: (data: any) => {
      setIsLoading(false);
      setloader(false);
      toast.success("Chat Unppined successfully!");
    },
    onError: (data: any) => {
      setIsLoading(false);
      setloader(false);
      toast.error(data?.response?.data?.message || "Something wrong.");
    },
  });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleOutsideClick = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      closeModal();
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isModalOpen]);

  const menuRef = useRef<HTMLDivElement | null>(null);

  const MessageInfo = useQuery({
    queryKey: ["get-message-details", smsId],
    queryFn: MessageDetailsApi,
    onSuccess: (resp: AxiosResponse) => {
      setMessagesDetails(resp.data?.details);
    },
    enabled: false,
  });
  const [searchChatMessageNumber, setsearchChatMessageNumber] = useState("");
  const [page, SetPage] = useState(1);
  const [limit, setLimit] = useState<number>(25);

  const SearchChatFilter = useQuery({
    queryKey: [
      "Number-Message-Search",
      encodeURIComponent(searchChatMessageNumber) || "",
      state.id || "",
      limit || 25,
      page || 1,
      NumberFilter === "Unread",
    ],
    queryFn: SearchNumberMessageApi,
    onSuccess: (resp: AxiosResponse) => {
      setSearchDetails(resp?.data?.data || []);
    },
    enabled: false,
  });

  useEffect(() => {
    if (!searchChatMessageNumber) return;
    const handler = setTimeout(() => {
      SearchChatFilter.refetch();
    }, 300);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchChatMessageNumber]);

  useEffect(() => {
    if (!searchChatMessageNumber) return;
    SearchChatFilter.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [NumberFilter]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setsearchChatMessageNumber(e.target.value);
  };

  const highlightSearchTerm = (message: string, searchTerm: string) => {
    if (!searchTerm) return message;

    const escapedSearchTerm = searchTerm.replace(
      /[-/\\^$*+?.()|[\]{}]/g,
      "\\$&"
    );

    const regex = new RegExp(`(${escapedSearchTerm})`, "gi"); // Now correctly escapes special characters
    const parts = message.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span key={index} style={{ color: "green" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  // Function to highlight search term
  const highlightSearchNumberTerm = (number: string) => {
    if (!searchChatMessageNumber) return number;

    // Escape special characters in the search term for the regular expression
    const escapedSearchTerm = searchChatMessageNumber.replace(
      /[-/\\^$*+?.()|[\]{}]/g,
      "\\$&"
    );
    const regex = new RegExp(`(${escapedSearchTerm})`, "gi"); // Create a regex to match the search term
    const parts = number.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === searchChatMessageNumber.toLowerCase() ? (
        <span key={index} style={{ color: "green" }}>
          {part}
        </span> // Highlight the matched part
      ) : (
        part
      )
    );
  };

  // Function to close the menu
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close the menu if clicked outside of it
  useEffect(() => {
    // Event listener to detect clicks outside the menu
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        closeMenu(); // Close the menu if clicked outside
      }
    };

    // Add event listener on component mount
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = (sms_id: number) => {
    if (isMenuOpen === false) {
      setIsMenuOpen(true);
    } else {
      setIsMenuOpen(false);
    }
    setSmsId(sms_id);
  };

  useEffect(() => {
    if (smsId) MessageInfo.refetch();
  }, [smsId]);

  const { mutate } = useMutation(CreateMessageApi, {
    mutationKey: "Message-Create",
    onSuccess: (data: any) => {
      setIsLoading(false);
      setloader(false);
      resetForm();
      setChatBoxGrammerError([]);
    },
    onError: (data: any) => {
      socket.emit("Chats", { campaignId: state?.id, number: openChat });
      setIsLoading(false);
      setloader(false);
      toast.error(data?.response?.data?.message || "Something wrong.");
    },
  });

  const OneToOneMessageCreate = useMutation(OneToOneMessageAPI, {
    mutationKey: "One-To-One-Message-Create",
    onSuccess: (data: any) => {
      setOneToOneLoader(false);
      setIsLoading(false);
      setIsModalOpen(false);
      handleClick(data.data?.number || "");
      setOneToOneGrammerError([]);
    },
    onError: (data: any) => {
      setOneToOneLoader(false);
      setIsLoading(false);
      toast.error(data?.response?.data?.message || "Something wrong.");
    },
  });

  const [retryLoading, setRetryLoading] = useState<{ [key: number]: boolean }>(
    {}
  );

  const handleRetryClick = (smsId: number) => {
    setRetryLoading((prevState) => ({
      ...prevState,
      [smsId]: true,
    }));

    RetryMessage.mutate({ sms_id: smsId });
  };

  const RetryMessage = useMutation(RetryMessageApi, {
    mutationKey: "Retry-Message",
    onSuccess: (resp: AxiosResponse, variables: any) => {
      setRetryLoading((prevState) => ({
        ...prevState,
        [variables.sms_id]: false,
      }));
    },
    onError: (error: any, variables: any) => {
      setRetryLoading((prevState) => ({
        ...prevState,
        [variables.sms_id]: false,
      }));

      toast.error(error.response?.data?.message || "Something went wrong.");
    },
  });

  const { errors, values, handleSubmit, resetForm, setFieldValue, submitForm } =
    useFormik<MessageType>({
      initialValues: {
        media: [],
        message: "",
      },
      validationSchema: MessageSchema,
      onSubmit: (data) => {
        if ((!data?.message.trim() && data.media.length <= 0) || isLoading)
          return;
        let appendID = Date.now();
        // setChats((preValue) => [
        //   ...preValue,
        //   {
        //     created_at: new Date().toLocaleString(),
        //     direction: "Outbound",
        //     from: "",
        //     to: "",
        //     id: 0,
        //     media_url: "[]",
        //     message: values?.message,
        //     sender_id: 0,
        //     status: 0,
        //     appendID: appendID,
        //   },
        // ]);
        // checkLastDivAppend();
        // resetForm();
        setIsLoading(true);
        setloader(true);
        mutate({
          campaignId: Number(state?.id),
          message: values?.message,
          number: openChat,
          type: data.media.length > 0 ? 2 : 1,
          appendID: appendID,
          media: data?.media,
        });
      },
    });

  const { refetch } = useQuery({
    queryKey: [
      "get-shortcut-messages",
      encodeURIComponent(values.message),
      state?.id,
    ],
    queryFn: ShortcutMessagesApi,
    onSuccess: (resp: AxiosResponse) => {
      setShortcutMessages(resp.data?.smsShortcutMessage || []);
    },
    enabled: false,
  });

  const handleChange = (text: string) => {
    setFieldValue("message", text?.replaceAll("$", ""));
    let Typing = text && isTextBoxFocus;
    if (Typing !== isTyping) setIsTyping(Typing ? true : false);
    setShowSugesation(
      text?.trim()?.charAt(0) === "#" && text?.split(" ").length === 1
    );
  };

  function checkLastDivAppend() {
    const Divs = document.querySelector("#newMsg");
    if (!Divs) setTimeout(checkLastDivAppend, 10);
    else Divs.scrollIntoView(true);
  }

  const handleMediaSelect = (event: any) => {
    setFieldValue("media", [
      ...values.media,
      ...(Array.from(event.target.files) as File[]),
    ]);
  };

  const handleRemoveFile = (index: number) => {
    const newFiles = [...values.media];
    newFiles.splice(index, 1);
    setFieldValue("media", newFiles);
  };

  const scrollBottom = () => {
    // if(chatListContainerRef.current) chatListContainerRef.current.scrollTop = chatListContainerRef.current.scrollHeight - chatListContainerRef.current.scrollHeight;
    document.querySelector("#BottomDiv")?.scrollIntoView(true);
  }

  useEffect(() => {
    socket.emit("Typing", { isTyping: isTyping });
    scrollBottom();
  }, [isTyping]);

  useEffect(() => {
    const resize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  useEffect(() => {
    socket.emit("Initialize", { campaignId: state?.id });
    checkLastDivAppend();
    socket.on("Typing", ({ users }: { users: TypingUsersType[] }) => {
      setTypingUsers(users || []);
      scrollBottom();
    });

    // socket.on("Numbers", ({ numbers }: { numbers: NumbersType[] }) => {
    //   setTimeout(() => {
    //     setLoading((pre) => ({ ...pre, number: false }));
    //   }, 300);
    //   setNumbers(numbers || []);
    //   setUnReadNumbers(numbers.filter((item) => item.unread_count > 0) || []);
    // });

    socket.on("Numbers", ({ numbers }: { numbers: NumbersType[] }) => {
      // setTimeout(() => {
        setLoading((pre) => ({ ...pre, number: false }));
      // }, 300);

      const filteredNumbers = numbers || [];
      const unreadNumbers = filteredNumbers.filter((item) => Number(item.unread_count) > 0 || []);

      setNumbers(filteredNumbers);
      setUnReadNumbers(numbers.filter((item) => item.unread_count > 0) || []);

      const totalUnread = unreadNumbers.reduce((acc, item) => acc + Number(item.unread_count), 0);
      setTotalUnreadCount(totalUnread);
    });


    socket.on("Chats", ({ chats, info, isAppend }: { chats: ChatsType[], info: any, isAppend: boolean | undefined }) => {
      setMessageListInfo(info);
      setIsChatListLoaded(true)
      // setTimeout(() => {
      setLoading((pre) => ({ ...pre, message: false }));
      setTimeout(() => {
        if (!isAppend) scrollBottom();
        else if (chatListContainerRef.current) chatListContainerRef.current.scrollTop = chats.length * 100
        setIsFirstChatListLoaded(true)
      }, 1);
      // }, 300);
      setChats((pre) => (isAppend ? [...pre.reverse(), ...(chats || [])] : chats || []).reverse());
    });
    socket.on("RefecthNumbers", () => {
      socket.emit("Initialize", { campaignId: state?.id });
    });
    socket.on(
      "View",
      ({ users, LastView }: { users: ViewersType[]; LastView: any }) => {
        setViewers(users);
        setLastView(LastView);
      }
    );

    socket.on("StatusUpdate", (newMessage: ChatsType) => {
      setChats((preValue) => {
        return preValue.map((item) => {
          if (newMessage?.id === item?.id) {
            return { ...newMessage };
          }
          return item;
        });
      });
    });

    socket.on("NewMessageArrived", (newMessage: ChatsType) => {
      socket.emit("MessageRead", {
        campaignId: state?.id,
        number: newMessage?.direction === "Inbound" ? newMessage.from : "",
      });

      // setChats((preValue) => {
      //   console.log(preValue, '>>>>>>>>>>>>>prevalue')

      //   if (!preValue.find((item) => newMessage?.appendID === item?.appendID))
      //     return [...preValue, newMessage];
      //   return preValue.map((item) => {
      //     if (
      //       item?.appendID &&
      //       newMessage?.appendID &&
      //       newMessage?.appendID === item?.appendID
      //     ) {
      //       return { ...newMessage };
      //     }
      //     return item;
      //   });
      // });

      setChats((preValue) => {
        const identifier = newMessage?.appendID ?? newMessage.id;

        const exists = preValue.find((item) => (item.appendID ?? item.id) === identifier);

        if (!exists) return [...preValue, newMessage];

        return preValue.map((item) => {
          if ((item.appendID ?? item.id) === identifier) {
            return { ...newMessage };
          }
          return item;
        });
      });
      scrollBottom();
    });
    return () => {
      socket.emit("UnView");
      socket.off("Typing");
      socket.off("Numbers");
      socket.off("Chats");
      socket.off("View");
      socket.off("StatusUpdate");
    };
  }, []);

  useEffect(() => {
    if (
      values.message.trim()?.charAt(0) === "#" &&
      values.message.split(" ").length === 1
    )
      refetch();
  }, [values.message]);

  const handleClick = (number: string) => {
    if (number === openChat) return;
    setChatBoxGrammerError([]);
    setLoading((pre) => ({ ...pre, message: true }));
    if (openChat) {
      handleUnView();
    }
    setIsBlockedNumber(false);
    setOpenChat(number);
    setChats([]);
    socket.emit("View", { campaignId: state?.id, number });
    socket.emit("Chats", { campaignId: state?.id, number });
    socket.emit("MessageRead", { campaignId: state?.id, number });
  };

  const handleBlockClick = (number: string) => {
    if (number === openChat) return;
    setChatBoxGrammerError([]);
    setLoading((pre) => ({ ...pre, message: true }));
    if (openChat) {
      handleUnView();
    }
    setIsBlockedNumber(true);
    setOpenChat(number);
    setChats([]);
    socket.emit("View", { campaignId: state?.id, number });
    socket.emit("Chats", { campaignId: state?.id, number });
    socket.emit("MessageRead", { campaignId: state?.id, number });
  };

  useEffect(() => {
    if (state?.Customer_Number) {
      if (state?.isBlockedNumber) {
        setNumberFilter("Blocklist");
        return handleBlockClick(state?.Customer_Number);
      }
      handleClick(state?.Customer_Number);
    }
  }, []);

  const handleUnView = () => {
    setChatBoxGrammerError([]);
    setOpenChat("");
    setIsBlockedNumber(false);
    resetForm();
    socket.emit("UnView");
    socket.emit("Initialize", { campaignId: state?.id });
  };

  const downloadMedia = async (imgUrl: string) => {
    fetch(imgUrl)
      .then((response) => response.blob())
      .then((blob) => {
        saveAs(blob, imgUrl.split("/").pop());
      })
      .catch(() => { });
  };

  useEffect(() => {
    scrollBottom();
  }, [Chats, typingUsers]);

  const [filteredNumbers, setFilteredNumbers] = useState(numbers);
  const searchTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current); // Clear the previous timeout
    }

    searchTimeout.current = setTimeout(() => {
      const lowerCaseQuery = searchQuery.toLowerCase();
      let a = NumberFilter === "Unread" ? unReadNumbers : numbers;
      const filtered = a.filter((item) =>
        item.number.toLowerCase().includes(lowerCaseQuery)
      );
      setFilteredNumbers(filtered);
    }, 300); // Delay of 500ms

    // Cleanup timeout on unmount
    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, [searchQuery, numbers]);

  const handleFormSubmit = (v: any) => {
    if ((!v?.message.trim() && v.media.length <= 0) || isLoading) return;
    setOneToOneLoader(true);
    setIsLoading(true);
    OneToOneMessageCreate.mutate({
      campaignId: Number(state?.id),
      message: v?.message,
      number: v?.number,
      type: v.media.length > 0 ? 2 : 1,
      media: v?.media,
      appendID: 0,
      from_number: v.from_number,
    });
  };

  const handleChatPin = (number: string, id: number) => {
    UserChatPin.mutate(
      { number: number, campaign_id: id },
      {
        onSuccess: (data: any) => {
          setIsLoading(false);
          setloader(false);
          toast.success("Chat pinned successfully!");
        },
        onError: (error: any) => {
          setIsLoading(false);
          setloader(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        },
      }
    );
  };

  const handleChatUnpin = (number: string, id: number) => {
    UserChatPinDelete.mutate({ number, campaign_id: id });
  };

  const handlePaste = (event: any) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;
    for (const item of items) {
      if (item.type.indexOf("image") !== -1) {
        const file = item.getAsFile();
        if (file) {
          setFieldValue("media", [...values.media, file]);
        }
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        !event.target.closest(".Numbers_Menu_Dropdown") &&
        !event.target.closest(".RiArrowDownSLine")
      ) {
        setShowMenuDrodown(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const NumbersItems = ({
    item,
    index,
  }: {
    item: NumbersType;
    index: number;
  }) => {
    return (
      <li
        className={`position-relative w-100 p-2 ${NumberFilter === "Unread"
          ? item?.unread_count > 0
            ? ""
            : "d-none"
          : ""
          }`}
      >
        <div
          onClick={() => handleClick(item?.number)}
          className={`d-flex overflow-hidden gap-2 justify-content-between align-items-center position-relative p-2 shadow-sm rounded-3 Numbers_Items cursor-pointer ${openChat === item?.number
            ? "bg-olive"
            : item?.unread_count > 0
              ? "bg-primary"
              : "bg-white"
            }`}
        >
          <div className="d-flex align-items-center">
            <FaUserCircle style={{ height: 32, width: 32 }} />
            <div className="px-2">
              <p className="fw-medium fs-12 mb-0">{item?.number}</p>
              <small className="fs-10">
                {new Date(item?.created_at).toLocaleString()}
              </small>
            </div>
          </div>
          <div className="d-flex align-items-center Numbers_Menu">
            <div className="d-flex justify-content-end align-items-center flex-grow-1 gap-2 pe-2">
              {item?.unread_count > 0 && (
                <small
                  className="bg-white rounded-5 p-1 text-center fw-bold"
                  style={{ width: 22, height: 22, fontSize: 10 }}
                >
                  {item?.unread_count}
                </small>
              )}
              {item?.isPin === 1 ? <RiPushpinFill /> : null}
              <RiArrowDownSLine
                onClick={(e) => {
                  e.stopPropagation();
                  setShowMenuDrodown((prev) => (prev === index ? null : index));
                }}
                className={`${openChat === item?.number || item?.unread_count > 0
                  ? "text-white"
                  : "text-black"
                  }`}
                size={22}
              />
            </div>
          </div>
        </div>
        <Dropdown
          onToggle={() => {
            setShowMenuDrodown(null);
          }}
          show={showMenuDropdown === index}
          className="Numbers_Menu_Dropdown"
        >
          <Dropdown.Menu>
            <Dropdown.Item className="px-0 text-center">
              {item?.isPin === 1 ? (
                <button
                  className="btn border-0 w-100 outline-none"
                  onClick={() =>
                    handleChatUnpin(item?.number, Number(state?.id))
                  }
                >
                  Unpin Chat
                </button>
              ) : (
                <button
                  className="btn border-0 w-100 outline-none"
                  onClick={() => {
                    handleChatPin(item?.number, Number(state?.id));
                  }}
                >
                  Pin Chat
                </button>
              )}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </li>
    );
  };
  
  const Numbers = (
    <div className="d-flex gap-2 flex-column h-100 overflow-x-auto py-3 pt-0 Numbers_List">
      <div className="pt-3 px-3 d-flex justify-content-between slign-items-center">
        <h4 className="mb-0">Chats</h4>
        <div className="">
          <RiChatNewFill
            className="fs-3 text-black-50 cursor-pointer"
            onClick={openModal}
          />
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="modal-overlay d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            ref={modalRef}
            className="modal-content p-sm-4 p-3 rounded shadow mx-4"
            style={{
              minWidth: "300px",
              maxWidth: "500px",
              backgroundColor: "ghostwhite",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Formik
              initialValues={{
                media: [],
                message: "",
              }}
              validationSchema={OneToOneMessageSchema}
              onSubmit={handleFormSubmit}
            >
              {({
                setFieldValue,
                values,
                errors,
                handleChange,
                submitForm,
              }) => {
                const handlePaste = (event: any) => {
                  const items = (
                    event.clipboardData || event.originalEvent.clipboardData
                  ).items;
                  for (const item of items) {
                    if (item.type.indexOf("image") !== -1) {
                      const file = item.getAsFile();
                      if (file) {
                        setFieldValue("media", [...values.media, file]);
                      }
                    }
                  }
                };
                return (
                  <Form>
                    <div className="mb-3">
                      <label htmlFor="from_number">From Number</label>
                      <Field
                        as="select"
                        id="from_number"
                        name="from_number"
                        className="form-control"
                      >
                        <option value="">Select From Number</option>
                        {gatewayNumbers.map((gateway: any, index: number) => (
                          <option key={index} value={gateway.gateway_number}>
                            {gateway.gateway_number}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="from_number"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="number">To Number</label>
                      <Field
                        type="text"
                        id="number"
                        name="number"
                        className="form-control"
                        placeholder="Enter To Number"
                      />
                      <ErrorMessage
                        name="number"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div>
                      {values?.media.length > 0 || true ? (
                        <div className="w-100 d-flex flex-wrap gap-3 pb-3 Files_Pre_Box">
                          {values?.media?.map((item: any, i) => {
                            let ext = item?.name.split(".").pop();
                            if (
                              ext === "png" ||
                              ext === "jpg" ||
                              ext === "jpeg"
                            )
                              return (
                                <div
                                  className={`showImages border-danger ${errors?.media?.[i] ? "Border" : ""
                                    }`}
                                  key={i}
                                >
                                  <IoClose
                                    color="black"
                                    className="my-1 removeImageBtn"
                                    onClick={() => {
                                      const newFiles = [...values.media];
                                      newFiles.splice(i, 1);
                                      setFieldValue("media", newFiles);
                                    }}
                                  />
                                  <img
                                    style={{ width: "100%", height: "100%" }}
                                    src={URL.createObjectURL(item)}
                                    alt="img"
                                  />
                                </div>
                              );
                            else
                              return (
                                <div
                                  className={`showImages bg-dark overflow-hidden border-danger ${errors?.media?.[i] ? "Border" : ""
                                    }`}
                                  key={i}
                                >
                                  <IoClose
                                    color="black"
                                    className="my-1 removeImageBtn"
                                    onClick={() => {
                                      const newFiles = [...values.media];
                                      newFiles.splice(i, 1);
                                      setFieldValue("media", newFiles);
                                    }}
                                  />
                                  <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                    <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                      {ext === "xls" ? (
                                        <BsFiletypeXls
                                          className="w-100 text-success"
                                          style={{ height: 35 }}
                                        />
                                      ) : ext === "xlsx" ? (
                                        <BsFiletypeXlsx
                                          className="w-100 text-success"
                                          style={{ height: 35 }}
                                        />
                                      ) : ext === "doc" ? (
                                        <BsFiletypeDoc
                                          className="w-100 text-primary"
                                          style={{ height: 35 }}
                                        />
                                      ) : ext === "docx" ? (
                                        <BsFiletypeDocx
                                          className="w-100 text-primary"
                                          style={{ height: 35 }}
                                        />
                                      ) : ext === "pdf" ? (
                                        <BsFiletypePdf
                                          className="w-100 text-danger"
                                          style={{ height: 35 }}
                                        />
                                      ) : (
                                        <FaFile
                                          className="w-100"
                                          style={{ height: 35 }}
                                        />
                                      )}
                                    </div>
                                    <p
                                      className="mb-2 fs-11 text-center"
                                      style={{ fontSize: 11 }}
                                    >
                                      {item?.name}
                                    </p>
                                  </div>
                                </div>
                              );
                          })}
                        </div>
                      ) : null}
                      {errors.media ? (
                        <small className="text-danger fw-bolder">
                          Accepted file types: pdf, doc, docx, xlsx, xls, png,
                          jpg, jpeg. Max file size: 1 MB.
                        </small>
                      ) : null}

                      {/* InputBox */}
                      <small className="text-danger fw-bold d-block">
                        {errors?.message}
                      </small>
                      {OneToOneGrammerError.map((error, i) => (
                        <small
                          key={i}
                          className="text-danger fw-bold d-block fs-12"
                        >
                          <strong>
                            {error.shortMessage} '
                            {values.message.slice(
                              error.offset,
                              error.offset + error.length
                            )}
                            ':
                          </strong>{" "}
                          {error?.replacements
                            .slice(0, 5)
                            .map((item) => item.value)
                            .join(", ")}
                        </small>
                      ))}
                      <div className="d-flex gap-2 align-items-center">
                        <GrammarValidator
                          placeholder="Type Message ..."
                          className="form-control flex-grow-1 Text_Box"
                          value={values.message}
                          onChange={(text) => {
                            setFieldValue("message", text?.replaceAll("$", ""));
                            let Typing = text && isTextBoxFocus;
                            if (Typing !== isTyping)
                              setIsTyping(Typing ? true : false);
                            setShowSugesation(
                              text?.trim()?.charAt(0) === "#" &&
                              text?.split(" ").length === 1
                            );
                          }}
                          onPaste={handlePaste}
                          style={{
                            resize: "none",
                            maxHeight: 158,
                            minHeight: 158,
                            overflowY: "auto",
                          }}
                          onValidationError={(err) =>
                            setOneToOneGrammerError(err)
                          }
                        />

                        <input
                          multiple
                          accept=".png, .jpg, .jpeg, .docx, .doc, .xlsx, .xls, .pdf"
                          ref={MediaInputRef2}
                          name="media"
                          type="file"
                          hidden
                          value=""
                          onChange={(event: any) => {
                            setFieldValue("media", [
                              ...values.media,
                              ...(Array.from(event.target.files) as File[]),
                            ]);
                          }}
                        />
                        <MdAttachFile
                          size={36}
                          className="Send-Btn p-2 bg-secondary shadow-sm cursor-pointer"
                          onClick={() => MediaInputRef2.current?.click()}
                        />
                        {!oneToOneSendLoader ? (
                          <IoMdSend
                            size={36}
                            className="Send-Btn p-2 pe-1 shadow-sm cursor-pointer"
                            onClick={submitForm}
                          />
                        ) : (
                          <button
                            className="buttonload Send-Btn border-0 cursor-pointer-none"
                            style={{ height: "36px", width: "34px" }}
                          >
                            <i className="fa fa-spinner fa-spin"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>

            <div>
              <IoMdClose
                onClick={closeModal}
                className="position-absolute text-light fs-4 d-sm-block d-none"
                style={{ right: "-30px", top: "5px" }}
              />
            </div>
            <div>
              <IoMdClose
                onClick={closeModal}
                className="position-absolute text-light fs-4 d-sm-block d-none"
                style={{ right: "-30px", top: "5px" }}
              />
            </div>
          </div>
        </div>
      )}

      <div className="w-100 position-sticky z-2 top-0 chat-box-bg">
        <div className="input-group  p-2 w-100 chat-box-bg">
          <div className="input-group-prepend">
            <span className="input-group-text bg-white">
              <IoSearch />
            </span>
          </div>
          {NumberFilter === "All" || NumberFilter === "Unread" ? (
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              onChange={handleSearchChange}
              value={searchChatMessageNumber as string}
            />
          ) : (
            <input
              type="search"
              className="form-control"
              placeholder="Search Blocklist Numbers"
              onChange={(e) => setSearchBlockListNumber(e.target.value)}
              value={SearchBlocklistNumber}
            />
          )}
        </div>
        <div className="w-100 d-flex px-3 gap-2 numbers_filter">
          <p
            className={`mb-0 item fs-12 ${NumberFilter === "All" ? "active" : ""
              }`}
            onClick={() => {
              setNumberFilter("All");
              // socket.emit("Numbers", {
              //   campaignId: state?.id,
              //   isUnread: false,
              // });
            }}
          >
            All
          </p>
          <p
            className={`mb-0 item fs-12 ${NumberFilter === "Blocklist" ? "active" : ""
              }`}
            onClick={() => setNumberFilter("Blocklist")}
          >
            Blocked Numbers
          </p>
          <p
            className={`mb-0 item fs-12 d-flex align-items-center ${NumberFilter === "Unread" ? "active" : ""
              }`}
            onClick={() => {
              setNumberFilter("Unread");
              // socket.emit("Numbers", { campaignId: state?.id, isUnread: true });
            }}
          >
            Unread
            {totalUnreadCount ?
              <p
                className={`${NumberFilter === "Unread" ? "bg-white" : "unreadtab_count text-white"} mb-0 ms-2 d-flex align-items-center justify-content-center fw-bold`}
                style={{
                  width: 20,
                  height: 20,
                  fontSize: 9,
                  borderRadius: 25,
                }}
              >
                {totalUnreadCount > 99 ? "99+" : totalUnreadCount}
              </p>
              : ""}
          </p>
        </div>
      </div>

      {NumberFilter === "All" || NumberFilter === "Unread" ? (
        <React.Fragment>
          {!searchChatMessageNumber ? (
            <Virtuoso
              className="list-unstyled"
              totalCount={NumberFilter === "Unread" ? unReadNumbers?.length || 1 : numbers.length || 1}
              itemContent={(index) =>
                numbers.length === 0 ? (
                  <li className="d-flex gap-2 align-items-center p-3 d-flex justify-content-center fw-bold text-secondary">
                    No Numbers Found
                  </li>
                ) : (
                  <NumbersItems
                    index={index}
                    key={index}
                    item={
                      NumberFilter === "Unread"
                        ? unReadNumbers[index]
                        : numbers[index]
                    }
                  />
                )
              }
            />
          ) : (
            <>
              {(SearchDetails?.numbers && SearchDetails.numbers.length > 0) ||
                (SearchDetails?.messages?.data &&
                  SearchDetails.messages.data.length > 0) ? (
                <Virtuoso
                  className="list-unstyled"
                  totalCount={
                    (SearchDetails?.numbers?.length || 0) +
                    (SearchDetails.messages.data.length || 0)
                  }
                  itemContent={(i) =>
                    SearchDetails?.numbers &&
                      SearchDetails.numbers.length > 0 ? (
                      <React.Fragment key={i}>
                        {i === 0 &&
                          SearchDetails?.numbers &&
                          SearchDetails.numbers.length > 0 ? (
                          <h6 className="px-3 mb-0">Contacts</h6>
                        ) : null}
                        {i === SearchDetails?.numbers?.length &&
                          SearchDetails?.messages?.data &&
                          SearchDetails.messages.data.length > 0 ? (
                          <h6 className="px-3 mb-0">Messages</h6>
                        ) : null}
                        {i < SearchDetails?.numbers?.length ? (
                          <div className="p-2">
                            <li
                              onClick={() =>
                                handleClick(SearchDetails.numbers[i]?.number)
                              }
                              key={i}
                              className={`d-flex gap-2 align-items-center p-2 shadow-sm rounded-3 cursor-pointer  ${openChat === SearchDetails.numbers[i]?.number
                                ? "bg-olive"
                                : SearchDetails.numbers[i]?.unread_count > 0
                                  ? "bg-primary"
                                  : "bg-white"
                                }`}
                            >
                              <FaUserCircle style={{ height: 34, width: 34 }} />
                              <div className="px-2">
                                <p className="fw-semibold h6 mb-0">
                                  {" "}
                                  {highlightSearchNumberTerm(
                                    SearchDetails.numbers[i]?.number
                                  )}
                                </p>
                                <small>
                                  {new Date(
                                    SearchDetails.numbers[i]?.created_at
                                  ).toLocaleString()}
                                </small>
                              </div>
                              <div className="d-flex justify-content-end align-items-center flex-grow-1">
                                {SearchDetails.numbers[i]?.unread_count > 0 && (
                                  <small
                                    className="bg-white rounded-5 p-1 text-center fw-bold"
                                    style={{
                                      width: 22,
                                      height: 22,
                                      fontSize: 10,
                                    }}
                                  >
                                    {SearchDetails.numbers[i]?.unread_count}
                                  </small>
                                )}
                              </div>
                            </li>
                          </div>
                        ) : (
                          <div
                            onClick={() =>
                              handleClick(
                                SearchDetails.messages.data[
                                  i - SearchDetails?.numbers?.length
                                ]?.number
                              )
                            }
                            style={{ cursor: "pointer" }}
                            className="message-item d-flex justify-content-between px-3 mb-3"
                          >
                            <div>
                              <p className="mb-0 fw-bold">
                                {
                                  SearchDetails.messages.data[
                                    i - SearchDetails?.numbers?.length
                                  ]?.number
                                }
                              </p>
                              <p
                                className="mb-2 text-secondary fw-semibold fs-12"
                                style={{ fontSize: "14px" }}
                              >
                                {formatDate(
                                  SearchDetails.messages.data[
                                    i - SearchDetails?.numbers?.length
                                  ]?.createdAt
                                )}
                              </p>
                              <p
                                className="mb-0 text-secondary fw-semibold pe-2"
                                style={{ fontSize: "14px" }}
                              >
                                {/* Highlight search term in green */}
                                {highlightSearchTerm(
                                  SearchDetails.messages.data[
                                    i - SearchDetails?.numbers?.length
                                  ]?.message,
                                  searchChatMessageNumber
                                )}
                              </p>
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    ) : null
                  }
                />
              ) : (
                ""
              )}

              {!SearchDetails?.numbers?.length &&
                !SearchDetails?.messages?.data?.length && (
                  <p className="d-flex gap-2 align-items-center p-3 d-flex justify-content-center fw-bold text-secondary">
                    No Records Found
                  </p>
                )}
            </>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Blocklist
            search={SearchBlocklistNumber}
            handleClick={handleBlockClick}
            openChat={openChat}
            showUnblocklist={showUnblocklist}
          />
        </React.Fragment>
      )}
    </div>
  );

  const MessageBox = (
    <>
      <div
        className={`flex-column h-100 overflow-x-auto pt-0 ${loading.message ? "d-flex" : "d-none"
          }`}
      >
        <div className="d-flex justify-content-center align-items-center w-100 h-100">
          <div>
            <h5 className="text-center text-secondary fs-sm">
              Getting All message.
            </h5>
            <BarLoader
              className="rounded-5"
              height={6}
              color="rgba(61, 153, 112, 0.5)"
              width={250}
            />
          </div>
        </div>
      </div>
      <div
        ref={chatListContainerRef}
        onScroll={handleScroll}
        className={`d-flex flex-column h-100 overflow-x-auto pt-0  ${loading.message ? "d-none" : "d-flex"
          }`}
      >
        {!openChat ? (
          <div className="d-flex gap-2 flex-column h-100 bg-white justify-content-center align-items-center me-2">
            <FaEnvelopeOpenText size={45} className="text-secondary" />
            <h5 className="text-center text-secondary">
              Select a Number to <br />
              Initiate a Conversation
            </h5>
          </div>
        ) : (
          <>
            <div
              className="input-group position-sticky top-0 w-100 d-flex justify-content-between flex-nowrap"
              style={{ background: "#d3d6de", zIndex: 999 }}
            >
              <div className="d-flex px-3 align-items-center flex-grow-1 flex-wrap">
                <div className="d-flex align-items-center">
                  <MdOutlineKeyboardBackspace
                    size={20}
                    onClick={handleUnView}
                    className="cursor-pointer"
                  />
                  <div className="d-flex align-items-center py-2">
                    <FaUserCircle size={28} />
                    <div className="px-md-2 px-1">
                      <p className="fw-bold fs-12 mb-0">{openChat}</p>
                      <div>
                        <p className="fw-semibold mb-0 fs-10 text-secondary ps-1">
                          last view by {LastView?.UserName}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {isBlockedNumber ? (
                  <button
                    className="btn btn-danger d-flex align-items-center gap-1 p-1 fs-10"
                    onClick={() => setShowUnblockList(true)}
                  >
                    <MdBlockFlipped />
                    Unblock Number
                  </button>
                ) : (
                  <button
                    className="btn btn-success d-flex align-items-center gap-1 p-1 fs-10"
                    onClick={() => setShowAddBlockList(true)}
                  >
                    <MdBlockFlipped />
                    Block Number
                  </button>
                )}
                <div>
                  <Select
                    options={dispositionStatus}
                    onChange={handleStatusChange}
                    placeholder="Select Disposition"
                    className="ps-sm-2 selectstatus-width text-nowrap py-sm-1 py-2"
                    value={
                      dispositionStatus.find(
                        (option) =>
                          option.label === statusInitialValue?.[0]?.status
                      ) || null
                    }
                    styles={{
                      container: (base) => ({ ...base, width: "200px" }),
                    }}
                  />
                </div>
              </div>

              <div className="d-flex gap-1 align-items-center px-3 user-select-none">
                {Viewers.length > 0
                  ? [...Viewers].slice(0, 2).map((item, i) => (
                    <React.Fragment key={i}>
                      <div
                        data-tooltip-id={"my-tooltip-" + i}
                        className={`direct-chat-img d-flex justify-content-center align-items-center bg-${colors[i % colors.length]
                          }`}
                      >
                        {item.name.trim().charAt(0).toUpperCase()}
                      </div>
                      <ReactTooltip
                        id={"my-tooltip-" + i}
                        place="bottom"
                        content={item?.name}
                      />
                    </React.Fragment>
                  ))
                  : null}
                {Viewers.length > 2 ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="transparent"
                      className="more_viewers_dropdown"
                    >
                      <div className="direct-chat-img d-flex justify-content-center align-items-center more_viewers">
                        +{Viewers.length - 2}
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="p-2">
                      <p className="border-bottom border-black pb-1 mb-0">
                        More viewers
                      </p>
                      <div className="d-flex gap-2 align-items-center pt-2 pb-1 user-select-none">
                        {[...Viewers]
                          .splice(2, Viewers.length)
                          .map((item, i) => (
                            <React.Fragment key={i}>
                              <div
                                data-tooltip-id={"my-tooltip-" + i + 1}
                                className={`direct-chat-img d-flex justify-content-center align-items-center bg-${colors[(i + 2) % colors.length]
                                  }`}
                              >
                                {item.name.trim().charAt(0).toUpperCase()}
                              </div>
                              <ReactTooltip
                                id={"my-tooltip-" + i + 1}
                                place="bottom"
                                content={item?.name}
                              />
                            </React.Fragment>
                          ))}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : null}
              </div>
              {/* <div className="d-flex gap-1 align-items-center pe-1 d-lg-none">
                <HiDotsVertical size={18} className="cursor-pointer" />
              </div>
              <div className="gap-1 align-items-center pe-3 d-none d-lg-flex">
                <HiDotsVertical size={24} className="cursor-pointer" />
              </div> */}
            </div>
            <div
              ref={menuRef}
              className="border w-100"
              style={{
                position: "absolute",
                top: "0px",
                right: isMenuOpen ? "0px" : "-100%",
                bottom: "0px",
                maxWidth: 500,
                background: "#f9f9f9",
                padding: "10px",
                transition: "all 300ms ease-in-out",
                zIndex: 1100,
              }}
            >
              <div className="overflow-auto h-100">
                {MessageDetails ? (
                  <div className="p-2">
                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <h6 className="fs-5 mb-0 fw-bold">Message Info</h6>
                      <button
                        onClick={() => closeMenu()}
                        className="border-0 bg-transparent fs-4"
                      >
                        &times;
                      </button>
                    </div>
                    <div className="message-details">
                      <h3 className="fw-bold" style={{ fontSize: "16px" }}>
                        Created By :{" "}
                        <span style={{ fontSize: "13px" }}>
                          {" "}
                          {MessageDetails.createdBy}
                        </span>
                      </h3>
                      <h3
                        style={{ fontSize: "16px" }}
                        className="text-secondary fw-bold"
                      >
                        Created At :{" "}
                        <span style={{ fontSize: "13px" }}>
                          {" "}
                          {formatDate(MessageDetails.createdAt)}
                        </span>
                      </h3>
                    </div>

                    <h6 className="views-header mb-2 pt-3 fs-5 fw-bold">
                      Views:
                    </h6>
                    <div className="views-list">
                      {MessageDetails.Views.map((view, index) => (
                        <div className="d-flex  align-items-center shadow shadow-1 rounded-2 mb-2 p-2">
                          <div className="p-2 me-2 fs-2">
                            <FaUserCircle />
                          </div>
                          <div key={index} className="">
                            <p className="mb-1 fw-bold">
                              {view.name}{" "}
                              <span
                                className="p-0 m-0 d-block fw-semibold"
                                style={{ fontSize: "13px" }}
                              >
                                {view.email}
                              </span>
                            </p>
                            <p
                              className="mb-1 text-secondary fw-semibold"
                              style={{ fontSize: "13px" }}
                            >
                              {formatDate(view.viewAt)}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <p className="loading">Loading...</p>
                )}
              </div>
            </div>
            <div className="d-flex flex-column gap-3 px-3 flex-grow-1 position-relative">
              <div className="msg-box" id="ChatBox">
                {Chats.map((item, i) => (
                  <div
                    className={`direct-chat-msg ${item?.direction === "Outbound" ? "right" : ""
                      }`}
                    key={i}
                    id={`${i === Chats.length - 1 ? "newMsg" : ""}`}
                  >
                    <div className="direct-chat-infos clearfix">
                      {item?.user?.name ? (
                        <small className="direct-chat-name fs-10">
                          {item?.user?.name}
                        </small>
                      ) : null}
                    </div>
                    <div className="direct-chat-infos clearfix">
                      {item?.sender_id === null ? (
                        <small className="direct-chat-name">
                          From Broadcast
                        </small>
                      ) : null}
                    </div>
                    <div className="Message">
                      <div>
                        <div
                          className={`d-flex flex-wrap gap-2 px-3 ${item?.direction === "Outbound"
                            ? "justify-content-end"
                            : ""
                            }`}
                          style={{ maxWidth: 348 }}
                        >
                          {isJSONString(item?.media_url) &&
                            JSON.parse(item?.media_url).map(
                              (
                                item: {
                                  media_url: string;
                                  content_type: string;
                                },
                                i: number
                              ) => {
                                if (item?.content_type?.startsWith("image/"))
                                  return (
                                    <div
                                      className="showImages bg-dark d-block"
                                      key={i}
                                    >
                                      <FiDownload
                                        color="black"
                                        className="my-1 removeImageBtn p-1"
                                        style={{ height: 25, width: 25 }}
                                        onClick={() =>
                                          downloadMedia(item?.media_url)
                                        }
                                      />
                                      <img
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        src={item?.media_url}
                                        alt="img"
                                        className="shadow-none object-fit-contain cursor-pointer"
                                        onClick={() => {
                                          setImage(item?.media_url);
                                          setShowImage(true);
                                        }}
                                      />
                                    </div>
                                  );
                                else
                                  return (
                                    <div
                                      className={`showImages bg-dark overflow-hidden`}
                                      key={i}
                                    >
                                      <FiDownload
                                        color="black"
                                        className="my-1 removeImageBtn"
                                        onClick={() =>
                                          downloadMedia(item?.media_url)
                                        }
                                      />
                                      <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                        <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                          {item?.content_type ===
                                            "application/vnd.ms-excel" ? (
                                            <BsFiletypeXls
                                              className="w-100 text-success"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                            <BsFiletypeXlsx
                                              className="w-100 text-success"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/msword" ? (
                                            <BsFiletypeDoc
                                              className="w-100 text-primary"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                            <BsFiletypeDocx
                                              className="w-100 text-primary"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/pdf" ? (
                                            <BsFiletypePdf
                                              className="w-100 text-danger"
                                              style={{ height: 35 }}
                                            />
                                          ) : (
                                            <FaFile
                                              className="w-100"
                                              style={{ height: 35 }}
                                            />
                                          )}
                                        </div>
                                        <p
                                          className="mb-2 fs-11 text-center"
                                          style={{ fontSize: 11 }}
                                        >
                                          {/* {item?.name} */}
                                        </p>
                                      </div>
                                    </div>
                                  );
                              }
                            )}
                        </div>
                        {isJSONString(item?.media_url) &&
                          JSON.parse(item?.media_url)?.length > 0 ? (
                          <small
                            className={`direct-chat-timestamp d-block mt-2 fs-10 px-3 text-dark ${item?.direction === "Outbound" ? "text-end" : ""
                              }`}
                          >
                            {DateFormat(item?.created_at)}
                          </small>
                        ) : null}
                        <div
                          className={`d-flex flex-column ${item?.direction === "Outbound"
                            ? "align-items-end"
                            : ""
                            }`}
                        >
                          {item?.message ? (
                            <div
                              className={`direct-chat-text mx-4 fs-14 position-relative`}
                              style={{ width: "fit-content" }}
                            >
                              {item?.direction === "Outbound" ? (
                                <div style={{ position: "relative" }}>
                                  <button
                                    className="border-0 fw-bold info-button text-black"
                                    style={{
                                      position: "absolute",
                                      top: "-10px",
                                      left: "-40px",
                                      background: "none",
                                      color: "inherit",
                                      cursor: "pointer",
                                    }}
                                    aria-label="Info"
                                    onClick={() => toggleMenu(item?.id)}
                                  >
                                    <CiCircleInfo size={20} />
                                  </button>
                                </div>
                              ) : (
                                <div style={{ position: "relative" }}>
                                  <button
                                    className="border-0 fw-bold info-button"
                                    style={{
                                      position: "absolute",
                                      top: "-10px",
                                      right: "-40px",
                                      background: "none",
                                      color: "inherit",
                                      cursor: "pointer",
                                    }}
                                    aria-label="Info"
                                    onClick={() => toggleMenu(item?.id)}
                                  >
                                    <CiCircleInfo size={20} />
                                  </button>
                                </div>
                              )}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item?.message?.replaceAll(
                                    /\n/g,
                                    "<br>"
                                  ),
                                }}
                              />
                              <small className="direct-chat-timestamp d-block mt-2 fs-10 text-end">
                                {DateFormat(item?.created_at)}
                              </small>
                            </div>
                          ) : null}
                          {item.direction === "Outbound" ? (
                            <small
                              className={`me-3 direct-chat-timestamp fw-bold fs-10 d-block text-end ${item?.status === 0 ||
                                item?.status === 5 ||
                                item?.status === 6
                                ? "text-warning"
                                : item?.status === 1
                                  ? "text-info"
                                  : item?.status === 4 ||
                                    item?.status === 7 ||
                                    item?.status === 3
                                    ? "text-danger"
                                    : "text-gray"
                                }`}
                            >
                              {item?.status === 0 ? (
                                "Pending"
                              ) : item?.status === 1 ? (
                                "Sent"
                              ) : item?.status === 2 ? (
                                "Delivered "
                              ) : item?.status === 3 ? (
                                "Undelivered"
                              ) : item?.status === 4 || item.status === 3 ? (
                                <>
                                  Failed
                                  {retryLoading[item.id] ? (
                                    <button
                                      className="border-0"
                                      style={{ width: "1px", height: "1px" }}
                                    >
                                      <i className="fa fa-refresh fa-spin"></i>
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => handleRetryClick(item.id)} // Pass the specific sms_id
                                      className="bg-transparent text-danger border-0 px-0"
                                      disabled={retryLoading[item.id]} // Disable while loading
                                    >
                                      <IoMdRefresh
                                        className="ms-1 cursor-pointer"
                                        title="Retry Message"
                                      />
                                    </button>
                                  )}
                                </>
                              ) : item?.status === 5 ? (
                                "Delivery Unknown"
                              ) : item?.status === 6 ? (
                                "Delivery Unconfirmed"
                              ) : item?.status === 7 ? (
                                "Unknown Gateway"
                              ) : (
                                ""
                              )}
                            </small>
                          ) : null}
                        </div>
                      </div>
                      {item?.direction === "Outbound" ? (
                        <div className="direct-chat-img d-flex justify-content-center align-items-center bg-success mt-2 mt-lg-0">
                          {item?.sender_id === null
                            ? "B"
                            : item.user?.name.trim().charAt(0).toUpperCase()}
                        </div>
                      ) : (
                        <div className="direct-chat-img d-flex justify-content-center align-items-center bg-secondary mt-2 mt-lg-0">
                          <FaUserCircle className="h-100 w-100" />
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                {typingUsers?.map((item, i) => (
                  <div
                    className="direct-chat-msg right"
                    key={i}
                    onLoad={() => scrollBottom()}
                  >
                    <div className="direct-chat-infos clearfix">
                      <small className="direct-chat-name">{item?.name}</small>
                    </div>
                    <div className="Message">
                      <div className={`direct-chat-text mx-3 fs-sm`}>
                        <PulseLoader
                          size={10}
                          speedMultiplier={0.9}
                          className="pt-1"
                        />
                      </div>
                      <div className="direct-chat-img d-flex justify-content-center align-items-center bg-success mt-2 mt-lg-0">
                        {item.name.trim().charAt(0).toUpperCase()}
                      </div>
                    </div>
                  </div>
                ))}
                <div id="BottomDiv" />
              </div>
            </div>
            <form
              className="position-sticky bottom-0 w-100 p-3"
              style={{ background: "#d3d6de", zIndex: 999 }}
              onSubmit={handleSubmit}
            >
              {/* Sugestions SMS */}
              {showSugestion ? (
                <div className="position-relative w-100">
                  <ul
                    className="bg-white list-unstyled rounded position-absolute overflow-x-auto shadow-sm"
                    style={{
                      bottom: 10,
                      left: 0,
                      right: 0,
                      maxHeight: 380,
                      maxWidth: 560,
                      border: "1px solid gray",
                    }}
                  >
                    {shortcutMessages.length === 0 ? (
                      <li className="p-2 cursor-pointer hover-gray">
                        <small className="mb-0 fw-semibold text-center d-block">
                          No shortcuts available.
                        </small>
                      </li>
                    ) : null}
                    {shortcutMessages?.map((item, i) => (
                      <li
                        key={i}
                        style={{ borderBottom: "1px solid gray" }}
                        className="p-2 cursor-pointer hover-gray"
                        onClick={() => {
                          setShowSugesation(false);
                          setFieldValue("message", item?.message);
                        }}
                      >
                        <p className="fw-bold mb-0">{item?.code}</p>
                        <small className="mb-0 fw-semibold">
                          {item?.message}
                        </small>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}

              {/* Show Selected Media */}
              {values?.media.length > 0 ? (
                <div className="w-100 d-flex flex-wrap gap-3 pb-3 Files_Pre_Box">
                  {values?.media?.map((item, i) => {
                    let ext = item?.name.split(".").pop();
                    if (ext === "png" || ext === "jpg" || ext === "jpeg")
                      return (
                        <div
                          className={`showImages border-danger ${errors?.media?.[i] ? "Border" : ""
                            }`}
                          key={i}
                        >
                          <IoClose
                            color="black"
                            className="my-1 removeImageBtn"
                            onClick={() => handleRemoveFile(i)}
                          />
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={URL.createObjectURL(item)}
                            alt="img"
                          />
                        </div>
                      );
                    else
                      return (
                        <div
                          className={`showImages bg-dark overflow-hidden border-danger ${errors?.media?.[i] ? "Border" : ""
                            }`}
                          key={i}
                        >
                          <IoClose
                            color="black"
                            className="my-1 removeImageBtn"
                            onClick={() => handleRemoveFile(i)}
                          />
                          <div className="w-100 h-100 d-flex flex-column justify-content-between">
                            <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                              {ext === "xls" ? (
                                <BsFiletypeXls
                                  className="w-100 text-success"
                                  style={{ height: 35 }}
                                />
                              ) : ext === "xlsx" ? (
                                <BsFiletypeXlsx
                                  className="w-100 text-success"
                                  style={{ height: 35 }}
                                />
                              ) : ext === "doc" ? (
                                <BsFiletypeDoc
                                  className="w-100 text-primary"
                                  style={{ height: 35 }}
                                />
                              ) : ext === "docx" ? (
                                <BsFiletypeDocx
                                  className="w-100 text-primary"
                                  style={{ height: 35 }}
                                />
                              ) : ext === "pdf" ? (
                                <BsFiletypePdf
                                  className="w-100 text-danger"
                                  style={{ height: 35 }}
                                />
                              ) : (
                                <FaFile
                                  className="w-100"
                                  style={{ height: 35 }}
                                />
                              )}
                            </div>
                            <p
                              className="mb-2 fs-11 text-center"
                              style={{ fontSize: 11 }}
                            >
                              {item?.name}
                            </p>
                          </div>
                        </div>
                      );
                  })}
                </div>
              ) : null}
              {errors.media ? (
                <small className="text-danger fw-bolder">
                  Accepted file types: pdf, doc, docx, xlsx, xls, png, jpg,
                  jpeg. Max file size: 1 MB.
                </small>
              ) : null}

              {/* InputBox */}
              <small className="text-danger fw-bold d-block">
                {errors?.message}
              </small>
              {ChatBoxGrammerError.map((error) => (
                <small className="text-danger fw-bold d-block fs-12">
                  <strong>
                    {error.shortMessage} '
                    {values.message.slice(
                      error.offset,
                      error.offset + error.length
                    )}
                    ':
                  </strong>{" "}
                  {error?.replacements
                    .slice(0, 5)
                    .map((item) => item.value)
                    .join(", ")}
                </small>
              ))}
              <div className="d-flex gap-2 align-items-center">
                <GrammarValidator
                  onFocus={() => setIsTextBoxFocus(true)}
                  onBlur={() => {
                    setIsTextBoxFocus(false);
                    setIsTyping(false);
                  }}
                  placeholder="Type Message ..."
                  className="form-control flex-grow-1 Text_Box"
                  onPaste={handlePaste}
                  value={values.message}
                  onChange={handleChange}
                  onValidationError={(err) => setChatBoxGrammerError(err)}
                  style={{
                    resize: "none",
                    maxHeight: 132,
                    height: "fit-content",
                    overflowY: "auto",
                  }}
                // maxLength={161}
                />

                <input
                  multiple
                  accept=".png, .jpg, .jpeg, .docx, .doc, .xlsx, .xls, .pdf"
                  ref={MediaInputRef}
                  name="media"
                  type="file"
                  hidden
                  value=""
                  onChange={handleMediaSelect}
                />
                <MdAttachFile
                  size={36}
                  className="Send-Btn p-2 bg-secondary shadow-sm cursor-pointer"
                  onClick={() => MediaInputRef.current?.click()}
                />
                {!loader ? (
                  <IoMdSend
                    size={36}
                    className="Send-Btn p-2 pe-1 shadow-sm cursor-pointer"
                    onClick={submitForm}
                  />
                ) : (
                  <button
                    className="buttonload Send-Btn border-0 cursor-pointer-none"
                    style={{ height: "36px", width: "34px" }}
                  >
                    <i className="fa fa-spinner fa-spin"></i>
                  </button>
                )}
              </div>
            </form>
          </>
        )}
      </div>
    </>
  );

  if (!state) return <Navigate to={"/chat-box/campaigns"} />;

  return (
    <React.Fragment>
      <ImageModal setShow={setShowImage} show={showImage} image={image} />
      <AddBlocklist
        show={showAddBlocklist}
        setShow={setShowAddBlockList}
        number={openChat}
        handleBlock={() => setIsBlockedNumber(true)}
      />
      <DeleteBlocklist
        show={showUnblocklist}
        setShow={setShowUnblockList}
        number={openChat}
        handleUnblock={() => {
          setIsBlockedNumber(false);
        }}
      />
      <AddStatus
        show={showStausList}
        setShow={setShowStausList}
        value={selectedStatus}
        number={openChat}
        initialvalue={Initial_Disposition_Status}
      />

      <div className="content-wrapper m-0 position-relative">
        <section className="content position-absolute h-100 w-100 px-0">
          <div className="container-fluid vh-100 pt-3 pb-2">
            <div className="card h-100">
              <div className="card-header bg-white p-3 d-flex flex-wrap justify-content-between align-items-center">
                <h2 className="h5 mb-0 flex-grow-1">{state?.name}</h2>
                <button
                  onClick={() => {
                    if (state?.isMultipleCampaign) {
                      navigate(-1);
                    } else {
                      navigate(-2);
                    }
                  }}
                  className="btn btn-info text-white d-flex align-items-center fw-semibold"
                  disabled={!state}
                >
                  <IoMdArrowRoundBack /> Back
                </button>
              </div>
              <div className="card-body chat-box-bg p-0">
                <div
                  className={`container-fluid overflow-hidden h-100 w-100 ${loading.number ? "" : "d-none"
                    }`}
                >
                  <div className="d-flex justify-content-center align-items-center w-100 h-100">
                    <div>
                      <h5 className="text-center text-secondary fs-sm">
                        Initializing the chat interface.
                      </h5>
                      <BarLoader
                        className="rounded-5"
                        height={6}
                        color="rgba(61, 153, 112, 0.5)"
                        width={250}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`container-fluid overflow-hidden h-100 w-100 ${loading.number ? "d-none" : ""
                    }`}
                >
                  {isMobile ? (
                    <div className="row h-100">
                      <div className="col-12 h-100 w-100 p-0 m-0">
                        <div className="d-block d-lg-none h-100 px-0">
                          {openChat ? (
                            <div className="p-0 h-100">{MessageBox}</div>
                          ) : (
                            <div className="p-0 h-100">{Numbers}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row h-100">
                      <div className="col-6 col-lg-3 h-100 px-0 d-none d-lg-block border-right border-black">
                        {Numbers}
                      </div>
                      <div className="col-6 col-lg-9 h-100 px-0 d-none d-lg-block">
                        {MessageBox}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}
